var map = {
	"./59.jpg": 4217,
	"./74.jpg": 298,
	"./84A-1.jpg": 2540,
	"./84A.jpg": 4814,
	"./84B.jpg": 9833,
	"./banner.jpg": 8845,
	"./community1.jpg": 1643,
	"./community2.jpg": 6476,
	"./community3.jpg": 4473,
	"./type1.jpg": 706,
	"./type2.jpg": 605
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 788;